module.exports = __webpack_public_path__ + "img/ardi_slogan.d02cd36a.png";